import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UserMessages = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        background:
          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
        textAlign: "center",
        padding: 2,
      }}
    >
      <Typography variant="h2" component="h1" sx={{ mb: 2, fontWeight: "bold" }}>
        Coming Soon!
      </Typography>
      <Typography variant="h6" sx={{ mb: 4, maxWidth: 400 }}>
        We’re working hard to bring you this feature. Stay tuned and check back soon!
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/")}
        sx={{
          backgroundColor: "#ff4081",
          "&:hover": {
            backgroundColor: "#f50057",
          },
          px: 4,
          py: 1.5,
          fontWeight: "bold",
          borderRadius: 3,
        }}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default UserMessages;
